import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-unfetch';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next'; // https://www.i18next.com/
import setJobPostingsParams from 'lib/setJobPostingsParams';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';
import FilterHeader from '@molecules/FilterHeader/FilterHeader';
import JobPostingsSplitView from '@molecules/JobPostingsSplitView/JobPostingsSplitView';
import { JobPostingType } from 'lib/proptypes/jobPosting';

const VacanciesPage = ({ totalResults, jobPostings = [] }) => {
  const { t } = useTranslation();
  return (
    <Layout title={t('jobPostingOverview.pageTitle')}>
      <FilterHeader
        numberOfVacancies={totalResults}
        autoCompleteLabel={t('jobPostingOverview.autoCompleteLabel')}
        autoCompletePlaceholder={t(
          'jobPostingOverview.autoCompletePlaceholder'
        )}
        placeLabel={t('jobPostingOverview.placeLabel')}
        placePlaceholder={t('jobPostingOverview.placePlaceholder')}
        submitLabel={t('jobPostingOverview.submitLabel')}
        withPlaceInput
      />

      <JobPostingsSplitView
        totalResults={totalResults}
        jobPostings={jobPostings}
      />
    </Layout>
  );
};

VacanciesPage.propTypes = {
  totalResults: PropTypes.number,
  jobPostings: PropTypes.arrayOf(JobPostingType),
};

export const getServerSideProps = async ({ req, res, locale, query }) => {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  const data = await fetch(
    `${process.env.NEXT_API_ROUTE}/elastic/job-postings?${setJobPostingsParams(
      query
    )}`
  );
  const json = await data.json();

  return {
    props: {
      totalResults: json?.totalResults || 0,
      jobPostings: json?.results || [],
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default VacanciesPage;
